// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import styled from 'styled-components';

export const Content = styled.div`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;

  @media (max-width: 992px) {
    padding-top: 7vh;
  }
`;
